<div class="cms-calendar" [ngClass]="{ 'disabled-dates-picking': isDisabledDatePicking }">
  <mat-calendar
    [startAt]="startAt"
    [(selected)]="selectedDate"
    (selectedChange)="onDateChange($event)"
    (monthSelected)="onMonthChange($event)"
    [dateFilter]="dateFilter"></mat-calendar>
</div>
